// Shared helpers for ChunkLoadError recovery (auto-reload with loop guard).
// Used by both <ChunkErrorBoundary> and global window error/rejection handlers
// in index.js, so the recovery logic stays consistent and we don't loop.

const STORAGE_KEY = 'airmaxxChunkReloadAt';
// If we already reloaded within this window, do NOT auto-reload again —
// fall through to the visible fallback instead.
const RECENT_WINDOW_MS = 30 * 1000;
// After this much time we forget the last reload mark entirely.
const COOLDOWN_MS = 5 * 60 * 1000;

export function isChunkError(error) {
  if (!error) return false;
  const msg = String(error.message || error || '');
  const name = String(error.name || '');
  return (
    name === 'ChunkLoadError' ||
    /Loading chunk\s+\S+\s+failed/i.test(msg) ||
    /Loading CSS chunk\s+\S+\s+failed/i.test(msg) ||
    /Failed to fetch dynamically imported module/i.test(msg)
  );
}

export function recentlyReloaded() {
  try {
    const at = parseInt(sessionStorage.getItem(STORAGE_KEY) || '0', 10);
    return at > 0 && Date.now() - at < RECENT_WINDOW_MS;
  } catch (_) {
    return false;
  }
}

export function markReload() {
  try {
    sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch (_) {
    /* ignore */
  }
}

export function clearStaleMark() {
  try {
    const at = parseInt(sessionStorage.getItem(STORAGE_KEY) || '0', 10);
    if (at > 0 && Date.now() - at > COOLDOWN_MS) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch (_) {
    /* ignore */
  }
}
